import { Decamelize } from '@helpers/object'
import { Session } from '@/sessions/models'
import { SW_CACHED_ROUTES } from '@/offline/constants'

type SessionSnakeCase = Decamelize<Session>

export const syncUpcomingSessions = async () => {
  try {
    //this request will be automatically cached by the service-worker (registerRoute)
    const response = await fetch(SW_CACHED_ROUTES.upcomingSessions, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': window.CSRFTOKEN,
        Accept: 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`${(response.status, response.statusText)}`)
    } else {
      const upcomingSessions: { sessions: SessionSnakeCase[] } =
        await response.json()

      return upcomingSessions
    }
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(`Failed to fetch upcoming sessions: ${e.message}`, {
        cause: e,
      })
    }
    throw e
  }
}
